module.exports = __webpack_public_path__ + "img/maintenance.352830b3.png";